// extracted by mini-css-extract-plugin
module.exports = {"suggestionsSection":"_3Yro-","suggestionsTitle":"_1M5gY"};